import { Modal } from "react-bootstrap";
import { useLanguage } from "../../../Translations/LenguageContext";
import FormatDateTime from "../../../Functions/FormatDate";
import { AiOutlineDislike, AiOutlineLike } from "react-icons/ai";

const GeoPromptInfoModal = ({
    show,
    handleClose,
    selectedPrompt
}) => {
    const { t } = useLanguage()

    return (
        <Modal show={show} centered onHide={handleClose}>
            <div className="modal_header">
                <p className="modal_header_title">
                    {t.geo.prompt_info}
                </p>
                {selectedPrompt?.rl_status && (
                    selectedPrompt?.rl_status == "POSITIVE" ? (
                        <span><AiOutlineLike /></span>
                    ) : (
                        <span><AiOutlineDislike /></span>
                    )
                )}
            </div>
            <div className="modal_main_cont">
                <div className="modal_profile_input_cont">
                    <div className="label_input" >
                        <label className="input_label">
                            {t.geo.prompt}
                        </label>
                        <div className="input_value">
                            {selectedPrompt?.prompt}
                        </div>
                    </div>

                    <div className="label_input" >
                        <label className="input_label">
                            {t.created_at}
                        </label>
                        <div className="input_value">
                            {FormatDateTime(selectedPrompt?.created_at)}
                        </div>
                    </div>

                    <div className="label_input" >
                        <label className="input_label">
                            {t.updated_at}
                        </label>
                        <div className="input_value">
                            {FormatDateTime(selectedPrompt?.updated_at)}
                        </div>
                    </div>

                    {!selectedPrompt?.id?.startsWith("prompt-0-0-") && (
                        <div className="label_input" >
                            <label className="input_label">
                                {t.geo.topics}
                            </label>
                            <div className="source_urls_list">
                                {selectedPrompt?.topics?.length > 0 && (
                                    selectedPrompt?.topics?.map((topic) => (
                                        <p className="source_url_item">{topic.name} - {t.geo[topic.intent_type]}</p>
                                    ))
                                )}
                            </div>
                        </div>
                    )}
                </div>

            </div>
            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                </div>
                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_close_btn"
                        onClick={handleClose}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default GeoPromptInfoModal;